export type YPaymentCurrency = 'SEK' | 'EUR';

export interface YPaymentAmount {
    value: number;
    currency: YPaymentCurrency;
}

export type YMultiCurrencyAmount = { [currency in YPaymentCurrency]: number };

export namespace $amount {
    export function getInCurrency(a: YMultiCurrencyAmount, c: YPaymentCurrency): YPaymentAmount {
        return { value: a[c] || 0, currency: c };
    }

    export function zero(currency?: YPaymentCurrency): YPaymentAmount {
        return { value: 0, currency: currency || '' as YPaymentCurrency };
    }

    export function canAdd(a: YPaymentAmount, b: YPaymentAmount): boolean {
        return a.currency == b.currency || b.value == 0 || a.value == 0;
    }

    export function add(a: YPaymentAmount, b: YPaymentAmount): YPaymentAmount {
        if(a.currency == b.currency)
            return { value: a.value + b.value, currency: a.currency }
        else if(b.value == 0)
            return { value: a.value, currency: a.currency }
        else if(a.value == 0)
            return { value: b.value, currency: b.currency }

        throw 'Can\'t add amounts in different currencies';
    }

    export function sub(a: YPaymentAmount, b: YPaymentAmount): YPaymentAmount {
        if(a.currency == b.currency)
            return { value: a.value - b.value, currency: a.currency }
        else if(b.value == 0)
            return { value: a.value, currency: a.currency }
        else if(a.value == 0)
            return { value: -b.value, currency: b.currency }

        throw 'Can\'t subtract amounts in different currencies';
    }

    export function neg(a: YPaymentAmount): YPaymentAmount {
        return { value: -a.value, currency: a.currency }
    }

    export function mul(a: YPaymentAmount, b: number): YPaymentAmount {
        return { value: Math.round(a.value * b), currency: a.currency }
    }

    export function div(a: YPaymentAmount, b: number): YPaymentAmount {
        return { value: Math.round(a.value / b), currency: a.currency }
    }
}
